'use strict';
import { storeToRefs } from 'pinia';
import rolePermissions from './role-permissions';
import { useAuthStore } from '../../auth/stores/auth-store';

/**
 * Is allowed - Composable function to check if user has access to resource and optionally the resource id
 * @param {String} resource - name of the resource tyring to be accessed using route name
 * @param {String|Array} [assert = null] - user id(s) that can be checked against logged in user id
 */
export const usePermissions = () => {
  /**
   * Auth
   */
  const { getFirebaseUser } = useAuthStore();
  const { authUser, loading, submitting, error } = storeToRefs(useAuthStore());

  /**
   * Is allowed - Composable function to check if user has access to resource and optionally the resource id
   * @param {String} resource - name of the resource tyring to be accessed using route name
   * @param {String|Array} [assert = false] - user id(s) that can be checked against logged in user id
   */
  const isAllowed = (resource, assert = false) => {
    const permissions = rolePermissions.get(authUser.value?.role ?? 'guest');
    //console.log('Permissions', permissions);

    if (authUser.value?.role === 'administrator') {
      return true;
    }

    // console.log('Resource', resource);
    // console.log('Assert', assert);
    // console.log('UID', user.value?.uid);
    if (assert) {
      return permissions.includes(resource) && assert === authUser.value?.uid;
    }

    if (assert === null) {
      return false;
    }

    // if (assert) {
    //   // Array of ids
    //   if (Array.isArray(assert)) {
    //     return permissions.includes(resource) && assert.includes(userId.value);
    //   }

    //   // Single id
    //   return permissions.includes(resource) && assert == userId.value;
    // }

    return permissions.includes(resource);
  };

  /**
   * Is allowed - Composable function to check if user has access to resource and optionally the resource id
   * @param {String} resource - name of the resource tyring to be accessed using route name
   * @param {String|Array} [assert = null] - user id(s) that can be checked against logged in user id
   */
  const isAllowedAsync = async (resource, assert = false) => {
    /**
     * Get firebase user and claims
     */
    await getFirebaseUser();

    return await isAllowed(resource, assert = false);
  };

  //prepare();

  return {
    isAllowed,
    isAllowedAsync,
  };
};
